import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const DropDownMenu = ({data}) => {
  const [open, setOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);

  return (
    <div className="w-full relative">
      <NavLink to={data.link}
        onClick={() => setOpen(!open)}
        className={({ isActive }) => `flex justify-between text-gray-200 ${isActive && "bg-gradient-to-tl from-yellow-900 to-yellow-500 text-white"} px-5 hover:bg-gradient-to-tl hover:from-yellow-900 hover:to-yellow-500 hover:text-white rounded-lg items-center py-2 cursor-pointer`}
      >
        <span className={`${open && "text-yellow-700"}`}>
          {data.name}
        </span>

        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.8"
          stroke="currentColor"
          className={`w-4 h-4 ${open && "rotate-180 stroke-blue-600"}`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
          />
        </svg> */}
      </NavLink>

      {/* sub menu */}
      {/* <div
        className={`${open ? "block" : "hidden"} w-full h-auto px-8`}
      >
        <div className="w-full">
          <div onClick={() => setOpenSubMenu(!openSubMenu)} className="w-full py-2 cursor-pointer flex justify-between items-center">
            <span className={`${openSubMenu && "text-blue-600"} text-[15px]`}>زیر منو</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.8"
              stroke="currentColor"
              className={`w-4 h-4 ${
                openSubMenu && "rotate-180 stroke-blue-600"
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </div>

          <div className={`${openSubMenu ? "block" : "hidden"} mt-1 px-5`}>
            <ul className="flex flex-col gap-3 text-sm pb-3">
                <li>موبایل</li>
                <li>موبایل</li>
                <li>موبایل</li>
                <li>موبایل</li>
                <li>موبایل</li>
                <li>موبایل</li>
            </ul>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default DropDownMenu;
